import {
    CHECKEDIN,
    GET_PARTICIPANT,
    GET_PARTICIPANTS,
    SET_LOADING,
    SET_PARTICIPANT_PAGINATION,
    SET_PARTICIPANTS,
} from '../types'

const ParticipantReducer = (state, action) => {

    switch (action.type) {

        case SET_PARTICIPANTS:
            return {
                ...state,
                participants: action.payload,
                loading: false
            }

        case GET_PARTICIPANTS:
            return {
                ...state,
                participants: action.payload,
                loading: false
            }

        case GET_PARTICIPANT:
            return {
                ...state,
                participant: action.payload,
                loading: false
            }

        case CHECKEDIN:
            return {
                ...state,
                checkedIn: action.payload,
                loading: false
            }

        case SET_PARTICIPANT_PAGINATION:
            return {
                ...state,
                participantPagination: action.payload,
                loading: false
            }

        case SET_LOADING:
            return {
                ...state,
                loading: true
            }

        default:
            return state
    }

}

export default ParticipantReducer
